import curd from '../curd'

const BASE_PATH = '/configure/device'

export default curd(BASE_PATH, {
  getCategories: () => ({
    url: `${BASE_PATH}/category`,
    method: 'GET'
  })
})



// WEBPACK FOOTER //
// ./src/apis/modules/Device.js